"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepKeysToSnake = void 0;

var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _deep = require("./deep");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keysToSnake = function keysToSnake(obj) {
  return (0, _mapKeys.default)(obj, function (value, key) {
    return (0, _snakeCase.default)(key);
  });
};
/**
 * Deeply converts all the object or array of object's keys to snake_case
 */


var deepKeysToSnake = function deepKeysToSnake(obj) {
  return (0, _deep.deep)(obj, keysToSnake);
};

exports.deepKeysToSnake = deepKeysToSnake;
//# sourceMappingURL=deepKeysToSnake.js.map